import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MAGICORE_API_URL } from '@magicore/core';

import { SharedModule } from '../shared/shared.module';
import { EntityEditorComponent } from './containers/entity-editor/entity-editor.component';
import { environment } from 'src/environments/environment';
import { EntityGroupComponent } from './containers/entity-group/entity-group.component';
import { EntityPropertyTextComponent } from './components/entity-property-text/entity-property-text.component';
import { EntityPropertyCheckboxComponent } from './components/entity-property-checkbox/entity-property-checkbox.component';
import { EntityPropertyPasswordComponent } from './components/entity-property-password/entity-property-password.component';
import { EntityPropertyButtonComponent } from './components/entity-property-button/entity-property-button.component';
import { EntityPropertySelectComponent } from './components/entity-property-select/entity-property-select.component';
import { EntityPropertyTextboxComponent } from './components/entity-property-textbox/entity-property-textbox.component';
import { EntityPropertyDatepickerComponent } from './components/entity-property-datepicker/entity-property-datepicker.component';
import { EntityPropertyNumericComponent } from './components/entity-property-numeric/entity-property-numeric.component';
import { EntityPropertyBooleanButtonComponent } from './components/entity-property-boolean-button/entity-property-boolean-button.component';
import { TooltipTextIdPipe } from './pipes/tooltip.pipe';
import { EntityPropertyEditorComponent } from './components/entity-property-editor/entity-property-editor.component';
import { EntityPropertyBaseComponent } from './components/entity-property-base/entity-property-base.component';
import { EntityPropertyWrapperComponent } from './containers/entity-property-wrapper/entity-property-wrapper.component';
import { NumberInputDirective } from './directives/number-input.directive';
import { TextInputComponent } from './components/input/text-input/text-input.component';
import { PasswordInputComponent } from './components/input/password-input/password-input.component';

@NgModule({
  declarations: [
    EntityEditorComponent,
    EntityGroupComponent,
    EntityPropertyBaseComponent,
    EntityPropertyTextComponent,
    EntityPropertyTextboxComponent,
    EntityPropertyCheckboxComponent,
    EntityPropertyButtonComponent,
    EntityPropertyPasswordComponent,
    EntityPropertySelectComponent,
    EntityPropertyDatepickerComponent,
    EntityPropertyNumericComponent,
    EntityPropertyBooleanButtonComponent,
    TooltipTextIdPipe,
    EntityPropertyEditorComponent,
    EntityPropertyWrapperComponent,
    NumberInputDirective,
    TextInputComponent,
    PasswordInputComponent
  ],
  imports: [CommonModule, SharedModule],
  providers: [{ provide: MAGICORE_API_URL, useValue: `${environment.apiUrl}` }],
  exports: [
    EntityEditorComponent,
    EntityGroupComponent,
    EntityPropertyEditorComponent,
    TooltipTextIdPipe,
    TextInputComponent,
    PasswordInputComponent,
    NumberInputDirective
  ]
})
export class EntityEditorModule {}
